export default 
{
	"Account": "Account",
	"AndSpace": " and ",
	"AreYouSureYouWantToDiscardYourChanges": "Are you sure you want to discard your changes?",
	"Close": "Close",
	"CloseSidebar": "CloseSidebar",
	"CloseThisDialogToRenewYourSessionAndContinue": "Close this dialog to renew your session and continue.",
	"CodeAuthenticated": "Code authenticated",
	"ConsentMessage": "I agree to the {agreements} provided by {orgName}.",
	"ContinueButton": "Continue",
	"ContinueWithEmail": "Continue with Email",
	"ContinueWithProvider": "Continue with {provider}",
	"Created": "Created",
	"Dialog": "Dialog",
	"DiscardChanges": "Discard Changes",
	"DueDate": "Due Date",
	"EditProfile": "Edit Profile",
	"Email": "Email",
	"EmailAddress": "Email Address",
	"EmailAddressIsRequired": "Email Address is required.",
	"EmailMustBeFormatted": "Email must be formatted as name@domain.com.",
	"EmailRequired": "Email address is required",
	"EntryCreated": "Entry Created",
	"EntryStatus": "Entry Status",
	"EntrySubmitted": "Entry Submitted",
	"EntryUpdated": "Entry Updated",
	"ErrorOccurred": "An error occurred",
	"GoodAfternoon": "Good Afternoon!",
	"GoodAfternoonWithName": "Good Afternoon, {name}!",
	"GoodEvening": "Good Evening!",
	"GoodEveningWithName": "Good Evening, {name}!",
	"GoodMorning": "Good Morning!",
	"GoodMorningWithName": "Good Morning, {name}!",
	"GroupTasksBy": "Group By",
	"HighPriority": "1 - High",
	"Homepage": "Home",
	"InactiveGuestError": "You are not an active guest of {orgName}.",
	"Incomplete": "Incomplete",
	"InvalidCode": "Invalid code",
	"KeepEditing": "Keep Editing",
	"Later": "Later",
	"LoginAsUserToAccessEntry": "Please log in as {requiredUser} to access this entry.",
	"LoginAsUserToAccessOrg": "Please log in as {requiredUser} to access {orgName}.",
	"LoginInstruction": "Please continue to access {orgName}.",
	"Logout": "Logout",
	"LowPriority": "3 - Low",
	"MediumPriority": "2 - Medium",
	"MyTasks": "My Tasks",
	"NextWeek": "Next Week",
	"NoTasks": "You don\u0027t have any tasks.",
	"OpenInNewTab": "Open in New Tab",
	"OpenSidebar": "Open Sidebar",
	"Or": "OR",
	"PastDue": "Past Due",
	"PleaseSelectARegistrationForm": "Please select a registration form.",
	"PoweredByCognito": "Powered by Cognito Forms",
	"Priority": "Priority",
	"PrivacyPolicy": "Privacy Policy",
	"PublicLink": "Public Link",
	"RegistrationListHeader": "How would you like to register?",
	"SkipToFormList": "Skip to Form List",
	"Status": "Status",
	"Submitted": "Submitted",
	"Tasks": "Tasks",
	"TermsOfService": "Terms of Service",
	"ThisOrganization": "this organization",
	"ThisWeek": "This Week",
	"Today": "Today",
	"Tomorrow": "Tomorrow",
	"Type": "Type",
	"Unprioritized": "Unprioritized",
	"UnsavedChanges": "Unsaved Changes",
	"Unscheduled": "Unscheduled",
	"Updated": "Updated",
	"Validating": "Validating",
	"VerificationInstruction": "Please enter the code sent to your email address to continue.",
	"VerificationResend": "Didn’t receive the code? Resend now.",
	"VerificationResending": "We\u0027re sending you another code now.",
	"VerificationTitle": "Verification Code",
	"You": "you",
	"YouAreNotAMemberOf": "You are not a member of {orgName}.",
	"YouDoNotHaveAccessToFormName": "You no longer have access to {formName}.",
	"YouDoNotHaveAccessToThisForm": "You do not have access to this form.",
	"YouMustAgree": "You must agree.",
	"YourSessionIsAboutToExpire": "Your session is about to expire"
};
